import { retrieveUserWishlist } from './dataExtractor';
import { createResourceLocatorString } from './routes';

export const upsertUserFavorites = ({ favorites = [], currentFavoriteId }) => {
  if (!favorites?.includes(currentFavoriteId)) {
    favorites?.push(currentFavoriteId);
  }
  return favorites;
};
export const upsertListingLikes = ({ likes = [], userId }) => {
  if (!likes.includes(userId)) {
    likes.push(userId);
  }
  return likes;
};

export const handleLocalFavoritesUpdate = currentFavoriteId => {
  const updatedFavorites = upsertUserFavorites({
    favorites: localFavorites,
    currentFavoriteId,
  });
  setLocalFavoritesItems(updatedFavorites);
};
/**
 * Saves wishlist data to sessionStorage and redirects to the LoginPage.
 * @param {Object} params - Parameters containing currentFavoriteId
 * @param {Array} likes - Array of likes to be filtered and saved
 * @param {Object} history - History object for navigation
 * @param {Function} createResourceLocatorString - Sharetribe routing utility
 * @param {Array} routeConfiguration - Sharetribe route configuration
 */
export const saveWishlistAndRedirectToLogin = params => {
  try {
    const { likes, history, routeConfiguration } = params || {};
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(
        'wishlist',
        JSON.stringify({
          currentFavoriteId: params.currentFavoriteId,
          likes: likes?.filter(Boolean) || [],
        })
      );
    }
    history.push(createResourceLocatorString('LoginPage', routeConfiguration, {}, {}));
  } catch (error) {}
};

/**
 * Retrieves wishlist data from sessionStorage.
 * @returns {Object|null} The wishlist data with favorites and likes, or null if not found or invalid.
 */
export const retrieveWishlistFromSession = () => {
  if (typeof window === 'undefined') return null;

  try {
    const wishlistData = sessionStorage.getItem('wishlist');
    if (!wishlistData) return null;

    const parsedData = JSON.parse(wishlistData);
    return {
      currentFavoriteId: parsedData.currentFavoriteId,
      likes: Array.isArray(parsedData.likes) ? parsedData.likes : [],
    };
  } catch (error) {
    return null;
  }
};
/**
 * Removes wishlist data from sessionStorage.
 * @returns {boolean} True if the wishlist was removed successfully, false otherwise.
 */
export const removeWishlistFromSession = () => {
  if (typeof window === 'undefined') return false;

  try {
    sessionStorage.removeItem('wishlist');
    return true;
  } catch (error) {
    return false;
  }
};

export const combineCartAndListings = (listings, cartItems) => {
  const listingsMap = listings.reduce((map, listing) => {
    map[listing.id.uuid] = listing;
    return map;
  }, {});

  const extendedListings = cartItems
    .flat()
    .map(id => listingsMap[id])
    .filter(Boolean);
  return extendedListings;
};
